import React, { RefObject } from 'react';
import {
  Theme
} from '@material-ui/core';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Icon, IconName } from '../../../icons';
import { BaseComponentWithModalSupport } from '../../baseDetail';
import { withOpenModal, WithOpenModalProps } from '../../modalDialogManager';
import { ROUTES } from '../../../navigation';

const withStylesFunction = withStyles(({ palette, spacing }: Theme) => ({
  root: {},
  actionIconRoot: {
    '&:not(:last-of-type)': {
      marginRight: spacing(1)
    }
  },
  actionIcon: {
    fontSize: '1.2rem'
  }
}));

type IconButtonClassKey = 'actionIconRoot' | 'actionIcon';

export type IconButtonProps = {
  createComponent?: {
    iconName?: IconName;
    component: React.ComponentType<BaseComponentWithModalSupport>;
    componentProps?: any;
    route: ROUTES;
  };
  onClick: () => void;
  classes: Partial<ClassNameMap<IconButtonClassKey>>;
  title: string;
  icon: IconName;
} & WithOpenModalProps;


type IconButtonState = {
  open: boolean;
};

class IconButton extends React.PureComponent<IconButtonProps, IconButtonState> {
  selectRef: RefObject<any>;

  constructor(props: IconButtonProps) {
    super(props);

    this.state = { open: false };
    this.selectRef = React.createRef<any>();
  }

  openModal = (event: React.MouseEvent<HTMLSpanElement>): void => {
    event.preventDefault();

    if (this.props.createComponent) {
      this.props.openModal(this.props.createComponent.component, this.props.createComponent.route, this.props.createComponent.componentProps);
    }
  };

  render(): React.ReactElement {
    console.debug('IconButton.render');

    return (
      <React.Fragment>
        <Icon
          iconName={this.props.icon}
          className={this.props.classes.actionIcon}
          IconProps={{
            classes: { root: this.props.classes.actionIconRoot },
            color: 'secondary',
            title: this.props.title,
            style: { cursor: 'pointer' },
            onClick: (event: React.MouseEvent<HTMLSpanElement>): void => {
              this.props.onClick();
              this.openModal(event);
            }
          }} />
      </React.Fragment>
    );
  }
}

export default withOpenModal(withStylesFunction(IconButton));
